import { POSTBACK_INDEX_0_VALUE, POSTBACK_INDEX_1_VALUE, POSTBACK_INDEX_2_VALUE } from '../../../../../../shared/constants';

export function convertSKANPostbackIndexToHumanReadable(index?: string) {
  switch (index) {
    case POSTBACK_INDEX_0_VALUE:
      return '0-2 days';
    case POSTBACK_INDEX_1_VALUE:
      return '3-7 days';
    case POSTBACK_INDEX_2_VALUE:
      return '8-35 days';
    default:
      return 'Unpopulated';
  }
}
